import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0999698b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon position-relative text-center" }
const _hoisted_2 = { class: "text position-absolute" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["list position-relative", {'router-link-exact-active': this.$route.name === _ctx.name}])
  }, [
    _createVNode(_component_router_link, {
      to: {name: _ctx.name},
      class: "position-relative d-flex justify-content-center align-items-center flex-column"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.icon),
            style: {"margin-top":"24px"}
          }, null, 2)
        ]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}